import React, { Component } from "react";
import { Button } from "antd";
import { Form, Icon, Label } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthLessThan,
  hasLengthGreaterThan,
  isNumeric,
} from "revalidate";

import { validatefromHome } from "../orderActions";

class ReferenceIdField extends Component {
  handleChange = (e) => {
    const { input, clearVisibleError } = this.props;
    input.onChange(e.target.value);
    if (clearVisibleError) {
      clearVisibleError();
    }
  };

  handleBlur = (e) => {
    this.props.input.onBlur(e.target.value);
  };

  render() {
    const {
      input,
      type,
      placeholder,
      visibleError,
    } = this.props;

    return (
      <Form.Field error={Boolean(visibleError)}>
        <input
          {...input}
          type={type}
          placeholder={placeholder}
          value={input.value || ""}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
        {visibleError ? (
          <Label basic color="red" className="validate-from-home-error">
            {visibleError}
          </Label>
        ) : null}
      </Form.Field>
    );
  }
}

class ValidateFromHome extends Component {
  state = {
    visibleError: "",
  };

  errorTimer = null;

  componentWillUnmount() {
    this.clearErrorTimer();
  }

  clearErrorTimer = () => {
    if (this.errorTimer) {
      clearTimeout(this.errorTimer);
      this.errorTimer = null;
    }
  };

  clearVisibleError = () => {
    this.clearErrorTimer();
    if (this.state.visibleError) {
      this.setState({ visibleError: "" });
    }
  };

  showErrorTemporarily = (message) => {
    this.clearErrorTimer();
    this.setState({ visibleError: message });
    this.errorTimer = setTimeout(() => {
      this.setState({ visibleError: "" });
      this.errorTimer = null;
    }, 3000);
  };

  handleFormSubmit = (data) => {
    this.clearVisibleError();
    this.props.validatefromHome(data.reference_id);
  };

  handleFormSubmitAttempt = (e) => {
    const { handleSubmit, valid, syncErrors } = this.props;
    if (!valid) {
      e.preventDefault();
      const message =
        (syncErrors && syncErrors.reference_id) || "Reference Id is required";
      this.showErrorTemporarily(message);
      return;
    }
    handleSubmit(this.handleFormSubmit)(e);
  };

  render() {
    const { loadingFormData } = this.props;
    const { visibleError } = this.state;

    return (
      <div className="validate-from-home">
        <Form
          error
          size="large"
          autoComplete="off"
          className="validate-from-home-form"
          onSubmit={this.handleFormSubmitAttempt}
        >
          <div className="validate-from-home-field">
            <Icon name="search" className="validate-from-home-icon" />
            <Field
              name="reference_id"
              component={ReferenceIdField}
              type="text"
              placeholder="Reference Id"
              visibleError={visibleError}
              clearVisibleError={this.clearVisibleError}
            />
          </div>
          <Button
            type="primary"
            htmlType="submit"
            className="validate-ref-submit"
            loading={loadingFormData}
          >
            Submit
          </Button>
        </Form>
      </div>
    );
  }
}

const validate = combineValidators({
  reference_id: composeValidators(
    isRequired({ message: "Reference Id is required" }),
    isNumeric({ message: "Numeric value only" }),
    hasLengthLessThan(21)({
      message: "Max. 20 characters allowed",
    }),
    hasLengthGreaterThan(7)({ message: "Min. 8 characters" })
  )(),
});

const actions = {
  validatefromHome,
};

const mapStateToProps = (state) => ({
  loadingFormData: state.orderForm.loadingOrderFromReferenceId,
  orderDetails: state.orderForm.orderDetailsFromReferenceId,
  syncErrors: state.form.validateOrderIdForm && state.form.validateOrderIdForm.syncErrors,
});

export default connect(
  mapStateToProps,
  actions
)(
  reduxForm({
    form: "validateOrderIdForm",
    validate,
    touchOnBlur: false,
    touchOnChange: false,
    enableReinitialize: true,
  })(ValidateFromHome)
);
